import type { Sponsor } from "./types";

export const fetchSponsors = async (): Promise<Sponsor[]> => {
  try {
    const res = await fetch("/data/sponsors.json", { cache: "no-cache" });
    return await res.json();
  } catch (err) {
    console.error("Impossible de charger sponsors.json", err);
    return [];
  }
};